import React, { useState, useEffect, useCallback, useRef } from "react";
import { useIntl } from "react-intl";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  InputAdornment
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useSelector, useDispatch } from "react-redux";

//Services
import DriverApi from "Services/Driver";

//Data
import countryCodeData from "./data/countryCode/index.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const PassengerCreate = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
      const authUser = useSelector((state) => state?.AuthReducer?.user || {});
  
  const dispatch = useDispatch();
  const intl = useIntl(); const t = intl.formatMessage;
  const [passengerimage, setpassengerimage] = useState("/assets/images/user/avatar.png");
  //pagination

  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );

  const subcmpnyName = useSelector(
    (state) => state?.AuthReducer?.subCmpny || ""
  );
  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };

  // Dropzone props
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: "image/*",
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        const file = acceptedFiles[0];

        // Convert file to Base64
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          formik.setFieldValue("passengerProfileImage", file); // Keep the file for form submission
          setpassengerimage(base64String); // Set the Base64 string for preview
        };
        reader.onerror = (error) => {
          console.error("Error converting file to Base64:", error);
        };
        reader.readAsDataURL(file); // Convert file to Base64
      }
    },
  });

  const handleAddDriver = (formValues) => {
    dispatch(showLoader(t({ id: "driver.loading" })));

    const formData = new FormData();
    formData.append("firstName", formValues?.firstName || "");
    formData.append("lastName", formValues?.lastName || "");
    formData.append("country", formValues?.country || "");
    formData.append("countryCode", formValues?.countryCode || "");
    formData.append("mobileNumber", formValues?.mobile || "");
    formData.append("email", formValues?.email || "");
    formData.append("password", formValues?.password || "");
    formData.append("passConfirmation", formValues?.passConfirmation || "");
    formData.append("gender", formValues?.gender || "");
    formData.append("address", formValues?.address || "");
    formData.append("driverLicenseNumber", formValues?.driverLicenseNumber || "");
    formData.append("corporate_user_id", authUser?.id || "");
    if (userType === "SUB COMPANY") formData.append("sub_companyName", subcmpnyName);
    if (formValues?.passengerProfileImage instanceof File) {
      formData.append("image", formValues.passengerProfileImage);
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200 || res?.status === 201) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || t({ id: "driver.modal.create.success" }),
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        setpassengerimage("/assets/images/user/avatar.png");
        handleClose();
      }
    };
    const onFailure = (err) => {
      const response = err?.response?.data;
      const messagesArray = response?.data || [];
      const messages = messagesArray.map(item => item.msg).join(", ");
      const errorMsg = messages || response?.message || response?.error || t({ id: "driver.modal.create.error" });

      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: errorMsg,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    DriverApi.addDriver(formData).then(onSuccess, onFailure);
  };

  // Formik
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      passConfirmation: "",
      gender: "",
      country: "",
      mobile: "",
      countryCode: "",
      corporate: "",
      corporateGroup: "",
      passengerProfileImage: "",
      address: "",
      driverLicenseNumber: "",
    },
    validationSchema: yup.object({
      firstName: yup.string().required(t({ id: "driver.validate.firstNameRequired" })).nullable(),
      email: yup
        .string()
        .email(t({ id: "driver.validate.invalidEmail" }))
        .required(t({ id: "driver.validate.emailRequired" }))
        .nullable(),
      countryCode: yup.string().required(t({ id: "driver.validate.countryCodeRequired" })).nullable(),
      mobile: yup
        .string()
        .matches(/^\d{1,15}$/, t({ id: "driver.validate.invalidMobile" }))
        .required(t({ id: "driver.validate.mobileRequired" }))
        .nullable(),
      password: yup.string()
        .min(6, t({ id: "driver.validate.passwordMin" }))
        .required(t({ id: "driver.validate.passwordRequired" }))
        .nullable(),
      passConfirmation: yup
        .string()
        .required(t({ id: "driver.validate.confirmPasswordRequired" }))
        .oneOf([yup.ref("password"), null], t({ id: "driver.validate.passwordsMismatch" }))
        .nullable(),
      gender: yup.string().required(t({ id: "driver.validate.genderRequired" })).nullable(),
      country: yup.string().required(t({ id: "driver.validate.countryRequired" })).nullable(),
      address: yup.string().required(t({ id: "driver.validate.addressRequired" })).nullable(),
      driverLicenseNumber: yup.string().required(t({ id: "driver.validate.licenseRequired" })).nullable(),
      passengerProfileImage: yup.mixed().required(t({ id: "driver.validate.profileImageRequired" })).nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleAddDriver,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleToggleNewPasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const countryCodes = Object.keys(countryCodeData);

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              {t({ id: "driver.modal.create.title" })}
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <section className={classes.avatarContainer}>
                <div className={classes.avatarWrapper}>
                  <div className={classes.avatar}>
                    <img
                      src={passengerimage}
                      alt="avatar"
                      className={classes.img}
                      style={{ objectFit: "cover" }}
                    />
                    <section
                      {...getRootProps()}
                      onClick={open}
                      className={classes.editIcon}
                    >
                      <input {...getInputProps()} />
                      <CameraAltOutlinedIcon />
                    </section>

                    {formik.errors.passengerProfileImage && formik.touched.passengerProfileImage && (
                      <Typography color="error" variant="caption">
                        {formik.errors.passengerProfileImage}
                      </Typography>
                    )}
                  </div>
                </div>
              </section>
            </Grid>
          </Grid>

          <Grid container>
            <section className={classes.container}>
              <Grid item xs={12} className={classes.detailsContainer}>
                <Grid container className={classes.containerWrapper}>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          id="firstName"
                          label={t({ id: "driver.field.firstName" })}
                          value={formik?.values?.firstName}
                          defaultValue={formik?.values?.firstName}
                          onChange={formik.handleChange}
                          error={
                            formik?.errors?.firstName &&
                            formik?.touched?.firstName
                          }
                          helperText={
                            formik?.errors?.firstName &&
                            formik?.touched?.firstName &&
                            formik?.errors?.firstName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="lastName"
                          id="lastName"
                          label={t({ id: "driver.field.lastName" })}
                          value={formik?.values?.lastName}
                          defaultValue={formik?.values?.lastName}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.lastName &&
                            formik?.touched?.lastName
                          }
                          helperText={
                            formik?.errors?.lastName &&
                            formik?.touched?.lastName &&
                            formik?.errors?.lastName
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        ></TextField>
                      </Grid>
                      <Grid item md={12} lg={12} xl={12}>
                        <Grid container>
                          <Grid
                            item
                            md={4}
                            lg={4}
                            xl={4}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                              name="countryCode"
                              id="countryCode"
                              label={t({ id: "driver.field.countryCode" })}
                              value={formik?.values?.countryCode}
                              defaultValue={formik?.values?.countryCode}
                              onChange={formik?.handleChange}
                              select
                              error={
                                formik?.errors?.countryCode &&
                                formik?.touched?.countryCode
                              }
                              helperText={
                                formik?.errors?.countryCode &&
                                formik?.touched?.countryCode &&
                                formik?.errors?.countryCode
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            >
                              {countryCodeData.map((country) => (
                                <MenuItem
                                  key={country.code}
                                  value={country.dial_code}
                                >
                                  {`${country.code} (${country.dial_code})`}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid
                            item
                            md={8}
                            lg={8}
                            xl={8}
                            className={classes.textFieldWrapper}
                          >
                            <TextField
                              inputProps={{
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                              name="mobile"
                              id="mobile"
                              label={t({ id: "driver.field.mobile" })}
                              value={formik?.values?.mobile}
                              defaultValue={formik?.values?.mobile}
                              onChange={formik?.handleChange}
                              error={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile
                              }
                              helperText={
                                formik?.errors?.mobile &&
                                formik?.touched?.mobile &&
                                formik?.errors?.mobile
                              }
                              fullWidth
                              variant="outlined"
                              size="small"
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="email"
                          id="email"
                          label={t({ id: "driver.field.email" })}
                          value={formik?.values?.email}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.email && formik?.touched?.email
                          }
                          helperText={
                            formik?.errors?.email &&
                            formik?.touched?.email &&
                            formik?.errors?.email
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="password"
                          id="password"
                          autoComplete="new-password"
                          value={formik?.values?.password}
                          onChange={formik?.handleChange}
                          type={showPassword ? "text" : "password"} // Toggle password visibility
                          fullWidth
                          variant="outlined"
                          size="small"
                          label={t({ id: "driver.field.password" })}
                          error={formik?.errors?.password && formik?.touched?.password}
                          helperText={
                            formik?.errors?.password &&
                            formik?.touched?.password &&
                            formik?.errors?.password
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle new password visibility"
                                  onClick={handleToggleNewPasswordVisibility}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="passConfirmation"
                          id="passConfirmation"
                          autoComplete="confirm-password"
                          value={formik?.values?.passConfirmation}
                          onChange={(e) => {
                            formik.handleChange(e);
                            formik.validateField("passConfirmation"); // Validate dynamically on each keystroke
                          }}
                          type={showConfirmPassword ? "text" : "password"} // Toggle password visibility
                          fullWidth
                          variant="outlined"
                          size="small"
                          label={t({ id: "driver.field.confirmPassword" })}
                          error={
                            formik?.errors?.passConfirmation && formik?.touched?.passConfirmation
                          }
                          helperText={
                            formik?.errors?.passConfirmation &&
                            formik?.touched?.passConfirmation &&
                            formik?.errors?.passConfirmation
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleToggleConfirmPasswordVisibility}
                                  edge="end"
                                >
                                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6} xl={6}>
                    <Grid container>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="gender"
                          id="gender"
                          select
                          label={t({ id: "driver.field.gender" })}
                          value={formik?.values?.gender || ""}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.gender && formik?.touched?.gender
                          }
                          helperText={
                            formik?.errors?.gender &&
                            formik?.touched?.gender &&
                            formik?.errors?.gender
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                          {["MALE", "FEMALE","OTHER"].map((option) => (
                            <MenuItem key={option} value={option}>
                              {option === "MALE" ? t({ id: "driver.field.male" }) : option === "FEMALE" ? t({ id: "driver.field.female" }) : t({ id: "driver.field.other" })}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="country"
                          id="country"
                          select
                          label={t({ id: "driver.field.country" })}
                          value={formik?.values?.country || ""}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.country && formik?.touched?.country
                          }
                          helperText={
                            formik?.errors?.country &&
                            formik?.touched?.country &&
                            formik?.errors?.country
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        >
                          {countryCodeData.map((country) => (
                            <MenuItem
                              key={country.code}
                              value={country.name}
                            >
                              {`${country.code} (${country.name})`}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="address"
                          id="address"
                          label={t({ id: "driver.field.address" })}
                          value={formik?.values?.address}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.address && formik?.touched?.address
                          }
                          helperText={
                            formik?.errors?.address &&
                            formik?.touched?.address &&
                            formik?.errors?.address
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.textFieldWrapper}
                      >
                        <TextField
                          inputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          name="driverLicenseNumber"
                          id="driverLicenseNumber"
                          label={t({ id: "driver.field.licenseNumber" })}
                          value={formik?.values?.driverLicenseNumber}
                          onChange={formik?.handleChange}
                          error={
                            formik?.errors?.driverLicenseNumber && formik?.touched?.driverLicenseNumber
                          }
                          helperText={
                            formik?.errors?.driverLicenseNumber &&
                            formik?.touched?.driverLicenseNumber &&
                            formik?.errors?.driverLicenseNumber
                          }
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      </Grid>








                    </Grid>
                  </Grid>


                </Grid>
                <Grid container >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.sbtBtnWrapper}
                  >
                    <Button variant="contained" onClick={formik?.handleSubmit}>
                      {t({ id: "driver.modal.create.submit" })}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </section>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>{t({ id: "driver.modal.close" })}</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PassengerCreate;
